<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined || error !== ''">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="()=>{$router.go(-1)}" >          
            <a-icon type="rollback" />&nbsp; Return          
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading">
            <div slot="title">
              R&D Notification Manifest
              <small class="m-display-block m-text-small">{{
                data.header.no_rndnotif
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom" v-if="!isAkuntansi">
              <!-- <span slot="title"> <a-icon type="printer" />&nbsp;Print </span> -->
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <!-- <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    >Manifest</a-button
                  >
                </li> -->
                <li>
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.is_revised &&
                          getAuth.username == data.header.tlc_pembuat
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="
                        !(
                          data.can_cancel &&
                          getAuth.username == data.header.tlc_pembuat
                        )
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                  </a-button-group>
                </li>
                <!-- <li>
                  <a class="m-display-block">SPK</a>
                </li> -->
              </ul>
              <!-- <a-button size="small">
                <a-icon type="printer" />
              </a-button> -->
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{ moment(data.header.tanggal).format(getDefaultDateFormat) }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{ data.header.tlc_pembuat }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Type R&D Notification</span>
                  <span class="m-list-desc">{{ data.header.type_rnd }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Project Name</span>
                  <span class="m-list-desc">{{ data.header.project_nm }}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{ data.header.deskripsi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Customer Name</span>
                  <span class="m-list-desc">{{ data.header.customer_nm }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Periode Development</span>
                  <span class="m-list-desc">{{
                    data.header.development_start ? moment(data.header.development_start).format(getDefaultDateFormat) : ""
                  }} - {{
                    data.header.development_end ? moment(data.header.development_end).format(getDefaultDateFormat) :""
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Due Date Inspection</span>
                  <span class="m-list-desc">{{
                    moment(data.header.due_date_insp).format(getDefaultDateFormat)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Spesial Requirment</span>
                  <span class="m-list-desc">{{
                    data.header.special_requirement
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Estimated Project Cost</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.header.currency, data.header.estimate_project_cost)
                  }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Bid Reasoning</span>
                  <span class="m-list-desc">{{
                    data.header.bid_reasoning
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>UP / RQ Number</span>
                  <span class="m-list-desc">{{ data.header.up_rfq_no }}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>Executor Site</span>
                  <span class="m-list-desc">{{
                    data.header.executor_site
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.header.catatan ? data.header.catatan : '-' }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card class="margin-top">
            <div slot="title">Purchase Details</div>
            <a-list
              itemLayout="vertical"
              :dataSource="data.detail"
              :pagination="pagination"
            >
              <Empty
                v-if="data.detail ? data.detail.length <= 0 : data.detail"
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{ item.product_work }}</span>
                  <div slot="description" class="margin-remove">
                    <!-- <div class="m-display-flex space-between">
                      <span>PN: {{ item.pn }}</span>
                    </div> -->
                    <div class="m-display-flex space-between">
                      <span
                        >QTY: {{ item.quantity }}&nbsp;{{
                          item.uni
                        }}</span
                      >
                    </div>
                    <div class="m-display-flex space-between">
                      <span>Note: {{ item.note }}</span>
                    </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card>
          <a-card
            class="margin-top"
            :loading="loading"
            v-if="data.jenis === 'Approve'"
          >
            <!-- <div slot="title">Manifest Actions</div> -->

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Actions">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  :loading="loadingSave"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Dokumen Pendukung</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.document">
                <Empty
                  v-if="
                    data.document ? data.document.length <= 0 : data.document
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <h4 class="m-list-dots margin-removes">
                        {{ item.nama_file }}
                      </h4>
                      <a-button
                        size="small"
                        type="default"
                        icon="cloud-download"
                        @click="handleDownload(item.url)"
                      ></a-button>
                    </div>
                    <p
                      slot="description"
                      :class="getScreen ? 'm-list-dots' : ''"
                    >
                      {{ item.deskripsi_doc }}
                    </p>
                    <img
                      class="m-image-icon"
                      slot="avatar"
                      src="@/assets/icon/pdf_ico.png"
                    />
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.header.tlc_pembuat }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ data.header.tlc }}</h4>
                    <h4 class="margin-remove">
                      {{ data.header.tanggal }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="
                        data.header.catatan === null ||
                        data.header.catatan === ''
                      "
                      >Tidak Ada Catatan</span
                    >
                    <span class="m-text-small" v-else>{{
                      data.header.catatan
                    }}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark !== null"
                      >{{ workflow.remark }}</span
                    >
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <!-- <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.description
                              ? item.description
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.description
                              ? item.description
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span class="m-timeline-title">{{
                        formatCurrency(data.mata_uang, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse> -->
        </a-col>
      </a-row>
      <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
        <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

        <ul class="m-list-wrapper bordered">
          <li v-for="history in data.history" :key="history.id_notifikasi">
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="m-display-flex space-between">
                <h3 class="margin-remove m-list-title">
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="m-display-flex space-between">
                <h3
                  class="margin-remove m-list-title"
                  v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                >
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <h3 class="margin-remove m-list-title" v-else>
                  {{ history.as_to }} | {{ history.tlc_to }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import Axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";

export default {
  name: "SalesNotificationManifest",
  props: ["id", "user_pembuat", "tlc"],
  mixins: [CurrencyFormat, HandleRoute],
  components: { "m-anim": lottie, Status },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getDefaultDateFormat"]),
    isAkuntansi(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='akuntansi'){
          res = true
        }
      });
      return res
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      loading: true,
      loadingSave: false,
      notfound: { animationData: notfound, loop: true },
      id_salesNotif: this.id,
      data: {
        status_app: [],
        header: [],
        detail: [],
        document: [],
        history: [],
        jenis: "",
        last_status: "",
        notifikasi: [],
        aksi: [],
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      visibleHistory: false,
      printLoad: {
        manifest: false,
        cancel: false,
      },
      error: "",
    };
  },
  mounted() {
    this.fetchManifest(this.id);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("handleCancel", this.canceltrans);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest(this.id);
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchManifest(to.params.id);
    next();
  },
  methods: {
    moment, 
    fetchManifest(value) {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "rnd_notification",
        params: {
          user_pembuat: this.user_pembuat ? this.user_pembuat : this.tlc,
          tlc: this.getAuth.username,
          id_manifest: value,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          // console.log(response);
          //this.data.status_app = response.data.status_app[0];
          this.data.header = response.data.header[0];
          this.data.detail = response.data.detail;
          this.data.document = response.data.document;
          this.data.dokumen_terkait = response.data.dokumen_terkait;
          this.data.history = response.data.history;
          this.data.jenis = response.data.jenis;
          this.data.status_app = response.data.status_app;
          this.data.last_status = response.data.last_status;
          this.data.notifikasi = response.data.notifikasi;
          this.data.aksi = response.data.aksi;
          this.data.is_revised = response.data.is_revised;
          this.data.can_cancel = response.data.can_cancel;
          this.loading = false;
        })
        .catch((err) => {
          //console.log(err);
          this.error = err;
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            // this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            // this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },

    handleDownload(item) {
      window.open(this.$serviceUrl + item, "_blank");
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.loadingSave = true;
        Axios({
          method: "POST",
          url: this.$serviceUrl + "rnd_notification/approval",
          processData: false,
          data: {
            id_manifest: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: { "X-API-KEY": this.getAuth.apikey },
        })
          .then((response) => {
            this.loadingSave = false;
            console.log(response);
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "sales_notification/cetak_laporan_salesnotif",
        responseType: "blob",
        params: {
          id_sales: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "salesnotif",
        id_manifest: this.id,
        code_trans: this.data.header.no_salesnotif,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "editRNDNotification",
        params: { id: this.id },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
